import { createQueryHook } from '../internal/createQueryHook';
import { getMetricEventsQuery } from '../queries/metricEvents';

/**
 * @deprecated Use `getMetricEventsQuery()` with `useQuery` directly.
 */
export const useEventActivityByProjModern = createQueryHook(getMetricEventsQuery);
